import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUtcOffsetStore } from 'src/models/useUtcOffsetModel';
import { formatTableTopX } from 'src/utils/table';

import { useDashboardServicesStore } from '../../../../models/useDashboardServicesModel';
import { ThreatType } from '../../../../utils/enums';
import { getServiceNamesByValues } from '../../../../utils/service';
import { generateRedirectUrlToLog } from '../../../Log/shared';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum } from '@Types/log';

function RansomwareTop5Senders(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const timeModel = useUtcOffsetStore();
  const servicesModel = useDashboardServicesStore();
  const config = [
    { width: '30%', grow: 1, align: 'left', tooltip: true },
    { width: '15%', grow: 0, align: 'right' },
    { width: '30%', grow: 1, align: 'left', tooltip: true },
    { width: '20%', grow: 0, align: 'left', tooltip: true },
  ];
  const header = [
    t('dashboard.chart.column.sender'),
    t('dashboard.chart.column.detections'),
    t('dashboard.chart.column.subject'),
    t('dashboard.chart.column.lastDetected'),
  ];

  const data = formatTableTopX(
    props.data?.ransomwareTopEmailSender?.[props.day],
    ['key', 'total', 'aliases', 'last_detected'],
    t,
    timeModel.offset
  ).map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'threatType',
              values: [ThreatType.Ransomware],
              type: 'terms',
            },
            {
              field: 'msgFrom',
              values: [row[0] as string],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
    row[2],
    row[3],
  ]);

  return (
    <DashboardCard
      title={t('dashboard.chart.title.ransomwareTop5Senders')}
      iconContent={t('dashboard.chart.desc.ransomwareTop5Senders')}
    >
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(RansomwareTop5Senders);
